import React from "react"
import { Avatar, Flex } from "@chakra-ui/react"
import APIconButton from "./APIconButton"
import { FullScreenContext } from "../contexts/FullScreenContext"
import { useSettingsContext } from "../contexts/SettingsContext";
import { useDeviceInfo } from "../contexts/DeviceContext";

import { ReactComponent as ArrowClose } from "../assets/icons/arrow-close.svg";
import { ReactComponent as ArrowOpen } from "../assets/icons/arrow-open.svg";
import { ReactComponent as Setting } from "../assets/icons/setting.svg";
import { useVocabIntl } from "../hooks/useVocabTranslation";

const NavMenu = (
  { profileBtnTabIndex, fullscreenBtnTabIndex, settingsBtnTabIndex }:
    {
      profileBtnTabIndex?: number,
      fullscreenBtnTabIndex?: number,
      settingsBtnTabIndex?: number
    }
) => {
  const { getFormattedString, locale } = useVocabIntl()
  const { profileData, avatar, setProfileOpen, setDefaultProfileTab, setSettingModalOpen } = useSettingsContext();
  const { inBrowser } = useDeviceInfo();

  return (
    <FullScreenContext.Consumer>
      {({ fullScreen, toggleFullScreen }) => (
        <Flex gap={4} justifyContent={"flex-end"} fontSize={"xl"} minHeight={"min"}>
          <APIconButton
            variant={"raisedIcon"}
            colorScheme={"secondary"}
            tabIndex={profileBtnTabIndex}
            onClick={() => {
              setDefaultProfileTab(0);
              setProfileOpen(true)
            }}
            aria-label={getFormattedString('aria-label-profile-menu')}>
            <Avatar
              style={{
                width: "1.25em",
                maxWidth: "1.25em",
                height: "1.25em",
                maxHeight: "1.25em",
                fontSize: "1em",
                margin: "-0.25em"
              }}
              src={avatar && avatar !== "0" ? `avatars/${avatar}.svg` : profileData ? undefined : `${process.env.REACT_APP_BASE_URL}/avatars/fire.svg`}
              name={locale === "fr" ? profileData?.username_fr : profileData?.username} />
          </APIconButton>
          {inBrowser &&
              <APIconButton
                  variant={"raisedIcon"}
                  colorScheme={"secondary"}
                  tabIndex={fullscreenBtnTabIndex}
                  onClick={() => toggleFullScreen()}
                  aria-label={getFormattedString('aria-label-fullscreen-button')}>
                {fullScreen ?
                  <ArrowClose style={{ width: "1em", height: "1em" }} /> :
                  <ArrowOpen style={{ width: "1em", height: "1em" }} />}
              </APIconButton>
          }
          <APIconButton
            variant={"raisedIcon"}
            colorScheme={"secondary"}
            tabIndex={settingsBtnTabIndex}
            onClick={() => setSettingModalOpen(true)}
            aria-label={getFormattedString('aria-label-options')}>
            <Setting style={{ width: "1em", height: "1em" }} />
          </APIconButton>
        </Flex>
      )}
    </FullScreenContext.Consumer>
  )
}

export default NavMenu